// @ts-nocheck
import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/ComingSoon.css";

export default function ComingSoon({
  title = "Marketplace coming soon",
  description = "Trading is live now. Buying & selling will unlock later.",
  icon = "📦",
  iconNode = null,
  ctaLabel = "Back to Trading",
  ctaTo = "/home",
  highlights = [],
}) {
  const navigate = useNavigate();

  return (
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        <div className="coming-soon-icon soon-icon">
          {iconNode || icon}
        </div>
        <h1>{title}</h1>
        <p>{description}</p>
        {highlights.length > 0 && (
          <ul className="coming-soon-highlights">
            {highlights.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        )}
        <button className="btn-back-trading" onClick={() => navigate(ctaTo)}>
          {ctaLabel}
        </button>
      </div>
    </div>
  );
}
